var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7803 4.46813L14.1968 0.884629C14.0919 0.779772 13.9582 0.708367 13.8128 0.679442C13.6673 0.650516 13.5165 0.665368 13.3795 0.722121C13.2425 0.778873 13.1254 0.874978 13.0429 0.998286C12.9605 1.12159 12.9165 1.26657 12.9165 1.41488V3.68588C12.9165 3.73561 12.8967 3.7833 12.8616 3.81846C12.8264 3.85363 12.7787 3.87338 12.729 3.87338H1.125C0.826631 3.87338 0.540483 3.99191 0.329505 4.20288C0.118526 4.41386 0 4.70001 0 4.99838C0 5.29675 0.118526 5.5829 0.329505 5.79387C0.540483 6.00485 0.826631 6.12338 1.125 6.12338H12.729C12.7787 6.12338 12.8264 6.14313 12.8616 6.1783C12.8967 6.21346 12.9165 6.26115 12.9165 6.31088V8.58188C12.9165 8.73019 12.9605 8.87517 13.0429 8.99847C13.1254 9.12178 13.2425 9.21789 13.3795 9.27464C13.5165 9.33139 13.6673 9.34624 13.8128 9.31732C13.9582 9.28839 14.0919 9.21699 14.1968 9.11213L17.7803 5.52863C17.9209 5.38798 17.9998 5.19725 17.9998 4.99838C17.9998 4.79951 17.9209 4.60878 17.7803 4.46813Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.b6aa265a5de3697bb5c172561e7f87ad.svg";
export { ForwardRef as ReactComponent };